import React, { useState, useEffect, useRef } from 'react';

import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaUserPlus, FaArrowLeft, FaArrowRight, FaLock, FaCheck, FaMapMarkerAlt } from 'react-icons/fa';
import Layout from '../components/layout/Layout';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo.png';
import { ghanaUniversities } from '../data/universities';
import { ghanaDepartments } from '../data/departments';
import { ghanaAcademicLevels } from '../data/academicLevels';
import { ghanaCourses } from '../data/courses';
import './RegisterStep3.css';

const RegisterStep3 = () => {
  const [errors, setErrors] = useState({});

  // Dropdown states
  const [showDepartmentDropdown, setShowDepartmentDropdown] = useState(false);
  const [showLevelDropdown, setShowLevelDropdown] = useState(false);
  const [showCourseDropdown, setShowCourseDropdown] = useState(false);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [filteredLevels, setFilteredLevels] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);

  // Refs for dropdowns
  const departmentInputRef = useRef(null);
  const departmentDropdownRef = useRef(null);
  const levelInputRef = useRef(null);
  const levelDropdownRef = useRef(null);
  const courseInputRef = useRef(null);
  const courseDropdownRef = useRef(null);
  const [formData, setFormData] = useState({
    school: '',
    level: '',
    programOfStudy: '',
    password: '',
    confirmPassword: '',
    businessDescription: '', // Only required for other sellers
    termsAccepted: false
  });
  
  // Account status for other sellers
  const [accountStatus, setAccountStatus] = useState('active'); // 'active' or 'on_hold'
  
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [redirectCountdown, setRedirectCountdown] = useState(5);
  
  // Dropdown visibility states

  
  // Filtered items for dropdowns

  
  // Refs for dropdown elements

  
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if we have data from previous steps
  useEffect(() => {
    if (!location.state?.email || !location.state?.firstName || !location.state?.role) {
      // If missing required data, redirect to step 1
      navigate('/register/step1');
    } else if (location.state?.school) {
      // Auto-select the school from Step 2
      setFormData(prev => ({
        ...prev,
        school: location.state.school
      }));
    }
    
    // Set account status based on seller type
    if (location.state?.sellerType === 'other') {
      setAccountStatus('on_hold');
    }
  }, [location.state, navigate]);

  // Check for existing success state on mount
  useEffect(() => {
    const storedSuccess = sessionStorage.getItem('registrationSuccess');
    if (storedSuccess === 'true') {
      console.log('Found stored success state, setting to true');
      setRegistrationSuccess(true);
      sessionStorage.removeItem('registrationSuccess'); // Clean up
    }
  }, []);

  // Monitor registrationSuccess state changes
  useEffect(() => {
    console.log('registrationSuccess changed to:', registrationSuccess);
    if (registrationSuccess) {
      console.log('SUCCESS STATE IS TRUE - should show success UI');
    }
  }, [registrationSuccess]);

  // Handle redirect countdown after successful registration
  useEffect(() => {
    if (registrationSuccess && redirectCountdown > 0) {
      const timer = setTimeout(() => {
        setRedirectCountdown(prev => prev - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (registrationSuccess && redirectCountdown === 0) {
      navigate('/login');
    }
  }, [registrationSuccess, redirectCountdown, navigate]);
  
    const validateField = (name, value) => {
    let errorMsg = '';
    switch (name) {
      case 'department':
      case 'level':
      case 'course':
        if (!value.trim()) errorMsg = 'This field is required.';
        break;
      case 'password':
        if (!value) {
          errorMsg = 'Password is required.';
        } else if (value.length < 6) {
          errorMsg = 'Password must be at least 6 characters.';
        }
        break;
      case 'confirmPassword':
        if (!value) {
          errorMsg = 'Please confirm your password.';
        } else if (value !== formData.password) {
          errorMsg = 'Passwords do not match.';
        }
        break;
      default:
        break;
    }
    setErrors(prev => ({ ...prev, [name]: errorMsg }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    validateField(name, value);

    // Filter dropdowns
    switch (name) {
      case 'department':
        filterDepartments(value);
        break;
      case 'level':
        filterLevels(value);
        break;
      case 'course':
        filterCourses(value);
        break;
      default:
        break;
    }
  };
  
    const filterDepartments = (searchTerm) => {
    if (!searchTerm.trim()) {
      setFilteredDepartments([]);
      setShowDepartmentDropdown(false);
      return;
    }
    const filtered = ghanaDepartments.filter(dept => dept.toLowerCase().includes(searchTerm.toLowerCase()));
    setFilteredDepartments(filtered);
    setShowDepartmentDropdown(filtered.length > 0);
  };

  const filterLevels = (searchTerm) => {
    if (!searchTerm.trim()) {
      setFilteredLevels([]);
      setShowLevelDropdown(false);
      return;
    }
    const filtered = ghanaAcademicLevels.filter(level => level.toLowerCase().includes(searchTerm.toLowerCase()));
    setFilteredLevels(filtered);
    setShowLevelDropdown(filtered.length > 0);
  };

  const filterCourses = (searchTerm) => {
    if (!searchTerm.trim()) {
      setFilteredCourses([]);
      setShowCourseDropdown(false);
      return;
    }
    const filtered = ghanaCourses.filter(course => course.toLowerCase().includes(searchTerm.toLowerCase()));
    setFilteredCourses(filtered);
    setShowCourseDropdown(filtered.length > 0);
  };

  

  

  

  
  // Validate form before submission
    const selectDepartment = (department) => {
    setFormData(prev => ({ ...prev, department }));
    setShowDepartmentDropdown(false);
    validateField('department', department);
  };

  const selectLevel = (level) => {
    setFormData(prev => ({ ...prev, level }));
    setShowLevelDropdown(false);
    validateField('level', level);
  };

  const selectCourse = (course) => {
    setFormData(prev => ({ ...prev, course }));
    setShowCourseDropdown(false);
    validateField('course', course);
  };

  const handleClickOutside = (event) => {
    if (departmentDropdownRef.current && !departmentDropdownRef.current.contains(event.target) && departmentInputRef.current && !departmentInputRef.current.contains(event.target)) {
      setShowDepartmentDropdown(false);
    }
    if (levelDropdownRef.current && !levelDropdownRef.current.contains(event.target) && levelInputRef.current && !levelInputRef.current.contains(event.target)) {
      setShowLevelDropdown(false);
    }
    if (courseDropdownRef.current && !courseDropdownRef.current.contains(event.target) && courseInputRef.current && !courseInputRef.current.contains(event.target)) {
      setShowCourseDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const validateStep = () => {
    // Reset error
    setError('');
    
    // Check required fields based on role
    if (location.state.role === 'seller' && location.state.sellerType === 'student') {
      if (
        !location.state.university_id ||
        !location.state.campus_id ||
        !formData.level ||
        !formData.programOfStudy
      ) {
        setError('Please fill in all academic information fields.');
        return false;
      }
    }
    
    if (location.state.sellerType === 'other' && !formData.businessDescription) {
      setError('Please provide a business description.');
      return false;
    }
    
    // Check password
    if (!formData.password) {
      setError('Password is required.');
      return false;
    }
    
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters.');
      return false;
    }
    
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match.');
      return false;
    }
    
    // Check terms acceptance
    if (!formData.termsAccepted) {
      setError('You must accept the Terms and Conditions.');
      return false;
    }
    
    return true;
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateStep()) {
      return;
    }
    
    setLoading(true);
    
    try {
      // Combine data from all steps
      const userData = {
        ...location.state,
        ...formData,
        accountStatus
      };
      // Debug: log the payload
      console.log('Registration payload:', userData);
      // Register user
      await register(userData);
      console.log('Registration successful!');
      
      // Store success in sessionStorage and update state
      sessionStorage.setItem('registrationSuccess', 'true');
      setRegistrationSuccess(true);
      setLoading(false);
      
    } catch (err) {
      setError(err.message || 'Failed to create account. Please try again.');
      setLoading(false);
    }
  };
  
  const handleBack = () => {
    // Add a small animation effect before navigation
    const backBtn = document.querySelector('.back-btn');
    if (backBtn) {
      backBtn.classList.add('clicked');
      setTimeout(() => {
        navigate('/register-step-2', { state: location.state });
      }, 200);
    } else {
      navigate('/register-step-2', { state: location.state });
    }
  };

  return (
    <Layout>
      <div className="register-step3-page-container">
        <div className="register-step3-split-screen">
          <div className="register-step3-left-panel">
            <div className="register-form-container">
              {registrationSuccess ? (
                <div className="registration-success-container">
                  <FaCheck className="success-icon" />
                  <h2>Registration Successful!</h2>
                  <p>Your account has been created successfully!</p>
                  {accountStatus === 'on_hold' && (
                    <div className="alert-warning">
                      Your seller account is currently on hold for verification. We will notify you once it's approved.
                    </div>
                  )}
                  <p className="redirect-message">
                    Redirecting to login page in <strong>{redirectCountdown}</strong> seconds...
                  </p>
                  <div className="redirect-actions">
                    <Link to="/login" className="continue-btn">Login Now</Link>
                    <button 
                      onClick={() => navigate('/login')} 
                      className="continue-btn secondary"
                    >
                      Skip Countdown
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <img src={logo} alt="UniTrade Logo" className="register-logo" />
                  <h2>Security & Terms</h2>
                  <p className="step-indicator">Step 3 of 3</p>
                  {location.state?.location && (
                    <p className="location-indicator"><FaMapMarkerAlt /> {location.state.location}</p>
                  )}
                  <div className="progress-bar-step3">
                    <div className="progress-step3" style={{ width: '100%' }}></div>
                  </div>

                  {error && <div className="alert-danger">{error}</div>}

                  <form onSubmit={handleSubmit} className="register-step3-form">
                    {location.state.role === 'seller' && location.state.sellerType === 'student' && (
                      <div className="form-section">
                        <h4>Academic Information</h4>
                                                <div className="input-group-register">
                          <label htmlFor="programOfStudy">Program of Study</label>
                          <input
                            type="text"
                            id="programOfStudy"
                            name="programOfStudy"
                            value={formData.programOfStudy}
                            onChange={handleChange}
                            placeholder="e.g., B.Sc. Computer Science"
                            required
                            autoComplete="off"
                          />
                        </div>
                                                <div className="input-group-register">
                          <label htmlFor="level">Level</label>
                          <select
                            name="level"
                            value={formData.level}
                            onChange={handleChange}
                            className="select-input"
                            required
                          >
                            <option value="">Select your level</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="300">300</option>
                            <option value="400">400</option>
                            <option value="500">500</option>
                            <option value="postgrad">Postgraduate</option>
                          </select>
                        </div>
                      </div>
                    )}

                    {location.state.role === 'seller' && location.state.sellerType === 'professional' && (
                      <div className="form-section">
                        <h4>Business Information</h4>
                        <div className="input-group-register">
                          <label htmlFor="businessDescription">Business Description</label>
                          <textarea id="businessDescription" name="businessDescription" value={formData.businessDescription} onChange={handleChange} placeholder="Tell us about your business..." required />
                        </div>
                      </div>
                    )}

                    <div className="form-section">
                      <h4>Set Your Password</h4>
                                            <div className="input-group-register">
                        <label htmlFor="password">Password</label>
                        <input type="password" id="password" name="password" value={formData.password} onChange={handleChange} placeholder="Enter your password" required />
                        {errors.password && <p className="error-text">{errors.password}</p>}
                      </div>
                                            <div className="input-group-register">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <input type="password" id="confirmPassword" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="Confirm your password" required />
                        {errors.confirmPassword && <p className="error-text">{errors.confirmPassword}</p>}
                      </div>
                    </div>

                    <div className="input-group-register terms-group">
                      <input type="checkbox" id="termsAccepted" name="termsAccepted" checked={formData.termsAccepted} onChange={(e) => setFormData(prev => ({...prev, termsAccepted: e.target.checked}))} />
                      <label htmlFor="termsAccepted">I agree to the <Link to="/terms">Terms and Conditions</Link></label>
                    </div>

                    <div className="form-navigation">
                      <button type="button" className="back-btn" onClick={handleBack}>
                        <FaArrowLeft /> Back
                      </button>
                      <button type="submit" className="continue-btn" disabled={loading}>
                        {loading ? 'Creating Account...' : 'Complete Registration'}
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
          <div className="register-step3-right-panel">
            <div className="cta-content">
              <FaCheck className="cta-icon" />
              <h2>Final Step!</h2>
              <p>Secure your account and agree to our terms to finalize your registration. Welcome to the community!</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RegisterStep3;